import LegalPage from "@/components/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage title="Disclaimer" lastUpdated="17 September 2026">
      <p>
        Please read this Disclaimer carefully before using <strong>voicematrix.in</strong>{" "}
        or purchasing any product or service from <strong>VoiceMatrixAI</strong>.
      </p>

      <h2>1. Not Medical Advice</h2>
      <p>
        The Service provides voice-frequency analysis and astrological insights for{" "}
        <strong>wellness reflection and self-care</strong>. It is <strong>not</strong> a
        medical device, diagnostic tool, or treatment.
      </p>
      <ul>
        <li>Nothing on the Service diagnoses, treats, cures, or prevents any disease or medical condition.</li>
        <li>Reports and recommendations do not replace consultation with a qualified medical practitioner.</li>
        <li>If you have a medical condition, are pregnant, are taking medication, or have concerns about your health, consult a licensed doctor before making any changes.</li>
      </ul>

      <h2>2. AI-Generated Content</h2>
      <p>Outputs from the Service are generated in part by artificial intelligence systems.</p>
      <ul>
        <li>AI outputs are assistive, not authoritative.</li>
        <li>Results may vary between sessions and are not guaranteed to be accurate or complete.</li>
        <li>AI-generated insights should be considered alongside professional advice, not as a substitute for it.</li>
      </ul>

      <h2>3. Astrological and Frequency-Based Insights</h2>
      <p>
        Our reports are based on <strong>Swar Nakshatra Jyotish</strong>, Vedic
        astrological principles, and frequency-based wellness frameworks. In our
        system, astrological associations are derived from vocal frequency patterns
        (the note and octave of your voice), not from birth data.
      </p>
      <ul>
        <li>These systems are traditional, interpretive, and non-scientific in the modern clinical sense.</li>
        <li>We do not claim that any astrological or frequency-based analysis predicts or determines specific life outcomes.</li>
        <li>Individual experiences with our products and services vary.</li>
      </ul>

      <h2>4. No Guarantee of Specific Outcomes</h2>
      <p>We do not guarantee that:</p>
      <ul>
        <li>Any report, remedy, or audio track will produce a specific result</li>
        <li>Health, wealth, relationships, or career outcomes will change in any particular way</li>
        <li>The Service will be uninterrupted, error-free, or free of inaccuracies</li>
      </ul>

      <h2>5. Personal Responsibility</h2>
      <p>You are solely responsible for:</p>
      <ul>
        <li>How you interpret and act on the information provided</li>
        <li>Decisions you make based on reports, remedies, or recommendations</li>
        <li>Consulting qualified professionals (medical, financial, legal) before acting on any insight</li>
      </ul>

      <h2>6. External Links and Third-Party Content</h2>
      <p>
        The Service may link to third-party websites, tools, or resources. We do not
        control and are not responsible for the content, accuracy, or practices of
        those third parties.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content on the Service — including reports, audio, PDFs, methodologies, and
        the Swar Nakshatra Jyotish framework — is protected by copyright and other
        intellectual property rights. Redistribution, resale, or public sharing is
        prohibited.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, <strong>VoiceMatrixAI</strong>, its
        directors, employees, and affiliates are not liable for any direct, indirect,
        incidental, or consequential damages arising from your use of the Service.
      </p>

      <h2>9. Modifications</h2>
      <p>
        We reserve the right to update this Disclaimer at any time. Changes are
        effective when posted on the site.
      </p>

      <h2>10. Contact</h2>
      <ul>
        <li><strong>VoiceMatrixAI</strong></li>
        <li><strong>Email:</strong> <a href="mailto:admin@voicematrix.in">admin@voicematrix.in</a></li>
        <li><strong>Address:</strong> Chandigarh, U.T., India</li>
      </ul>
    </LegalPage>
  );
}